import Background, { BackgroundVariant } from 'app/components/Background'
import Container, { MaxWidth } from 'app/components/Container'
import Footer from 'app/components/Footer'
import Header from 'app/components/Header'
import Main from 'app/components/Main'
import Popups from 'app/components/Popups'
import { classNames } from 'app/functions'
import React, { FC, useEffect } from 'react'
import Image from 'next/image'

interface TridentHeaderProps {
  className?: string
  pattern?: BackgroundVariant
  maxWidth?: MaxWidth
  condensed?: boolean
}

export const TridentHeader: FC<TridentHeaderProps> = ({
  children,
  className,
  pattern,
  maxWidth = '7xl',
  condensed,
}) => {
  useEffect(() => {
    document.body.classList.add('portfolio_page')
    return () => {
      document.body.classList.remove('portfolio_page')
    }
  }, [])
  return (
    <>
      <div className="top_bg_prnt top_bg_prnt_prtfl">
        <Image src="/images/portfolio_bg.svg" alt="" height="494px" width="1496px" />
      </div>

      <div className="def_lpddng">
        <div className="respncv_pdng">
          <header className="relative flex flex-col items-center justify-center w-full farmHeader min_prnt_bg nls_prnt_bg">
            {/* <Background variant={pattern} /> */}
            <Container
              maxWidth={maxWidth}
              className={classNames(
                'portfolio now_woeth_as flex flex-col gap-5  z-[1] lg:py-10',
                condensed && 'py-5',
                className
              )}
            >
              <div className="as_flxrow">{children}</div>
            </Container>
          </header>
        </div>
      </div>
    </>
  )
}

interface TridentBodyProps {
  className?: string
  maxWidth?: MaxWidth
}

export const TridentBody: FC<TridentBodyProps> = ({ children, className, maxWidth = '7xl' }) => {
  useEffect(() => {
    document.body.classList.add('farm_page')
    return () => {
      document.body.classList.remove('farm_page')
    }
  }, [])
  return (
    <Container
      maxWidth={maxWidth}
      className="col-span-10 lg:col-span-8 3xl:col-span-7 ">
      {children}
    </Container>
  )
}

const TridentLayout: FC = ({ children = [] }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <div className="flex flex-col items-center flex-grow w-full">
        <div className="flex flex-col flex-grow w-full">{children}</div>
        <Popups />
      </div>
      <Footer />
    </div>
  )
}

export default TridentLayout
